import { Quote } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { SmartLink } from "./SmartLink";

export const STORIES = [
  {
    id: "eccd-walking",
    program: "ECCD",
    href: "/early-childhood-care-and-development-eccd",
    image: "/images/g2.jpg",
    name: "[Child's name], [age]",
    outcome: "From lying down in isolation all day to walking independently, through sensory and mobility exercises.",
    quote: "[Quote from the parent or caregiver]",
  },
  {
    id: "eccd-words",
    program: "ECCD",
    href: "/early-childhood-care-and-development-eccd",
    image: "/images/p8.jpg",
    name: "[Child's name], [age]",
    outcome: "Now speaks basic words like Ma, Mami and Doodh (milk), and is starting to form simple sentences.",
    quote: "[Quote from the parent or caregiver]",
  },
  {
    id: "ie-school",
    program: "Inclusive Education",
    href: "/inclusive-education",
    image: "/images/p9.jpg",
    name: "[Child's name], [age]",
    outcome: "Identified through screening and supported with an individualised learning plan to stay in school.",
    quote: "[Quote from the child, parent or teacher]",
  },
  {
    id: "ie-materials",
    program: "Inclusive Education",
    href: "/inclusive-education",
    image: "/images/g3.jpg",
    name: "[Child's name], [age]",
    outcome: "Learning alongside classmates with accessible learning materials and a trained teacher.",
    quote: "[Quote from the child, parent or teacher]",
  },
];

const StoryCard = ({ s, i }) => (
  <Reveal delay={(i % 2) * 0.1} className="h-full">
    <article data-testid={`story-card-${s.id}`} className="group h-full grid sm:grid-cols-5 rounded-[28px] overflow-hidden bg-white border border-[#0F1D2F]/10 hover:border-[#CF5C0F] transition-colors">
      <div className="sm:col-span-2 relative aspect-[4/3] sm:aspect-auto overflow-hidden">
        <img src={s.image} alt={s.outcome} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
        <span className="absolute top-4 left-4 bg-[#FAF7F2]/90 backdrop-blur text-[#B34C0A] font-mono text-xs tracking-[0.15em] uppercase px-3 py-1.5 rounded-full">{s.program}</span>
      </div>
      <div className="sm:col-span-3 p-7 flex flex-col">
        <Quote className="w-8 h-8 text-[#E69A28]" />
        <p data-testid={`story-quote-${s.id}`} className="font-serif italic text-2xl text-[#0F1D2F] mt-3 leading-snug">{s.quote}</p>
        <p className="mt-4 text-[#3A4756] leading-relaxed flex-1">{s.outcome}</p>
        <div className="mt-6 flex items-center justify-between gap-3">
          <p data-testid={`story-name-${s.id}`} className="font-semibold text-[#0F1D2F]">{s.name}</p>
          <SmartLink href={s.href} data-testid={`story-link-${s.id}`} className="shrink-0 whitespace-nowrap text-sm font-semibold text-[#B34C0A] hover:text-[#0F1D2F] transition-colors">
            Read more →
          </SmartLink>
        </div>
      </div>
    </article>
  </Reveal>
);

export const Stories = ({ program, tone = "cream" }) => {
  const list = program ? STORIES.filter((s) => s.program === program) : STORIES;
  return (
    <section data-testid="stories-section" className={`py-20 lg:py-28 ${tone === "sand" ? "bg-[#F3EADF]" : "bg-[#FAF7F2]"}`}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Eyebrow testId="stories-eyebrow">Stories of Change</Eyebrow>
        <Reveal>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#0F1D2F] mt-5 leading-[1] tracking-tight">
            Little steps, <em className="text-fire">big wins.</em>
          </h2>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6 lg:auto-rows-fr">
          {list.map((s, i) => (
            <StoryCard key={s.id} s={s} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
